// Client Dashboard Page

import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@store/auth.store';
import { SimpleBackground } from '../../components/effects/ParticleBackground';
import { StatCard, StatGrid, StatCardSkeleton } from '../../components/ui';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui';
import { Button } from '../../components/ui';
import { Server, FileText, LifeBuoy, DollarSign, ShoppingBag, ArrowRight, Flame } from 'lucide-react';

export default function DashboardPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="space-y-8">
      <SimpleBackground />

      {/* Welcome Section */}
      <div className="animate-fade-in">
        <h1 className="text-3xl font-bold text-white">
          Welcome back, <span className="text-orange-500">{user?.firstName}</span>!
        </h1>
        <p className="text-slate-400 mt-1">Here's what's happening with your account today.</p>
      </div>

      {/* Stats Grid */}
      <StatGrid columns={4}>
        <StatCard
          title="Active Services"
          value={0}
          icon={Server}
          color="orange"
        />
        <StatCard
          title="Unpaid Invoices"
          value={0}
          icon={FileText}
          color="yellow"
        />
        <StatCard
          title="Open Tickets"
          value={0}
          icon={LifeBuoy}
          color="green"
        />
        <StatCard
          title="Credit Balance"
          value="$0.00"
          icon={DollarSign}
          color="purple"
        />
      </StatGrid>

      {/* Empty State */}
      <Card variant="glass" hoverable={false} padding="lg">
        <CardContent className="text-center py-8">
          <ShoppingBag className="w-16 h-16 text-slate-600 mx-auto" />
          <h3 className="text-xl font-semibold text-white mt-4">No services yet</h3>
          <p className="text-slate-400 mt-2">
            Get started by ordering your first service.
          </p>
          <div className="mt-6">
            <Button variant="primary" glow>
              Browse Services
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
